export { XLMouthpiecesMobileSlider } from './XLMouthpiecesMobileSlider'